import type { WithActiveBranchId } from '@app/api/shared';

export enum TagsEndpoints {
  GetTagById = 'GetTagById',
  UpdateTag = 'UpdateTag',
  GetTags = 'GetTags',
  GetClientTags = 'GetClientTags',
  SetClientsTags = 'SetClientsTags',
  RemoveClientsTags = 'RemoveClientsTags',
  SetClientsTagsBySearchId = 'SetClientsTagsBySearchId',
  UpdateClientTags = 'UpdateClientTags',
  GetListTags = 'GetListTags',
  GetAllTags = 'GetAllTags',
}

export interface ModelTag {
  Id: number;
  Name: string | null;
  Color: string | null;
  IconId: string | null;
  Description: string | null;
  IsDeleted: boolean;
  IsSelected: boolean;
  IsSystem: boolean;
  SystemId: string | null;
}

export interface ModelClientsTags {
  ClientIds: number[] | null;
  TagIds: number[] | null;
}

export interface ModelClientsTagsBySearchId {
  SearchId: number;
  TagIds: number[] | null;
}

export type GetTagByIdRequest = WithActiveBranchId<{
  tagId: number;
}>;

export type UpdateTagRequest = WithActiveBranchId<{
  data: ModelTag;
  // Лог-заголовки (HeaderUserId/HeaderDatabase) — по ним на бэке разбирают
  // инциденты создания/обновления тега, паритет с удалённым v1-updateTag.
  logs?: {
    isLogged: boolean;
    userId: number | null;
    database: string | null;
  };
}>;

export type GetTagsRequest = WithActiveBranchId<{
  onlyClient?: boolean;
}>;

export type GetClientTagsRequest = WithActiveBranchId<{
  clientId: number;
}>;

export type SetClientsTagsRequest = WithActiveBranchId<{
  data: ModelClientsTags;
}>;

export type RemoveClientsTagsRequest = WithActiveBranchId<{
  data: ModelClientsTags;
}>;

export type SetClientsTagsBySearchIdRequest = WithActiveBranchId<{
  data: ModelClientsTagsBySearchId;
}>;

export type UpdateClientTagsRequest = WithActiveBranchId<{
  clientId: number;
  data: number[];
}>;

export type GetListTagsRequest = WithActiveBranchId;

export type GetAllTagsRequest = WithActiveBranchId;

export type GetTagByIdResponse = ModelTag;
export type UpdateTagResponse = ModelTag;
export type GetTagsResponse = ModelTag[];
export type GetClientTagsResponse = ModelTag[];
export type SetClientsTagsResponse = void;
export type RemoveClientsTagsResponse = void;
export type SetClientsTagsBySearchIdResponse = void;
export type UpdateClientTagsResponse = void;
export type GetListTagsResponse = ModelTag[];
export type GetAllTagsResponse = ModelTag[];
